import { render, staticRenderFns } from "./PedidoDetalhes.vue?vue&type=template&id=7bd42ca6"
import script from "./PedidoDetalhes.vue?vue&type=script&lang=js"
export * from "./PedidoDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports